<template>
  <v-card class="px-2">
    <v-form ref="form" v-model="valid">
      <v-card-title> {{ t("core_values.title_s") }} Details </v-card-title>
      <v-card-subtitle>
        Customize your {{ t("core_values.title_s") | lower }} name, category and
        description
      </v-card-subtitle>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="coreValue.name"
              outlined
              label="Name"
              maxlength="50"
              :rules="[$rules.required]"
              required
              :disabled="!is_admin"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-select
              v-model="coreValue.categoryId"
              :items="corevalue_categories"
              :label="`${t('core_values.title_s')} category`"
              outlined
              item-text="name"
              item-value="id"
              :rules="[$rules.required]"
              required
              :disabled="!is_admin"
              dense
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="newBehaviorText"
              outlined
              maxlength="250"
              :placeholder="
                `What examples exhibit ${$options.filters.lower(
                  coreValue.name
                )} in your company?`
              "
              label="Add Behavior"
              dense
              color="primary"
              validate-on-blur
            >
              <template v-slot:append-outer>
                <v-btn
                  height="40"
                  color="primary"
                  @click="addBehavior"
                  :disabled="!newBehaviorText"
                  v-if="is_admin"
                >
                  Add
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" v-for="(behavior, i) in behaviors" :key="i">
            <v-text-field
              v-model="behavior.value"
              :label="`${t('core_values.behavior_title_s')} ${i + 1}`"
              outlined
              maxlength="250"
              :rules="[$rules.required]"
              required
              :disabled="!is_admin"
              dense
            >
              <template v-slot:append-outer>
                <v-btn
                  icon
                  @click="removeBehavior(i)"
                  tabindex="-1"
                  v-if="is_admin"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="is_admin" class="pt-0">
        <v-btn @click="save" :loading="saving">{{ saveButtonText }}</v-btn>
        <v-btn
          v-if="coreValue.id"
          text
          @click="deleteCoreValue"
          :loading="saving"
        >
          Remove Core Value
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CoreValueForm",
  components: {},
  data: () => ({
    valid: true,
    saving: false,
    newBehaviorText: "",
    behaviors: []
  }),
  watch: {
    coreValue(val, old) {
      if (this._.isEmpty(old)) {
        this.$refs.form.resetValidation();
      }
      if (val != old) {
        this.setBehaviors();
      }
    }
  },
  computed: {
    saveButtonText() {
      return this.coreValue.id ? "Update" : "Add";
    },
    ...mapGetters({
      coreValue: "company/edit_corevalue",
      corevalue_categories: "lookup/corevalue_categories",
      is_admin: "profile/is_admin"
    })
  },
  created() {
    this.setBehaviors();
  },
  methods: {
    setBehaviors() {
      this.behaviors = this.coreValue.behaviors;
    },
    addBehavior() {
      this.behaviors.push({ value: this.newBehaviorText });
      this.newBehaviorText = "";
    },
    removeBehavior(index) {
      this.behaviors.splice(index, 1);
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.coreValue.behaviors = this.behaviors;
        this.$store
          .dispatch("company/saveCoreValues", [this.coreValue])
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess(
              `${this.t("core_values.title_s")} saved.`
            );
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while saving"
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    async deleteCoreValue() {
      if (
        await this.$root.$confirm(
          `Delete ${this.t("core_values.title_s", true)}`,
          `Are you sure you want to delete this ${this.t(
            "core_values.title_s",
            true
          )}?<br><br>All reporting data will be lost if this ${this.t(
            "core_values.title_s",
            true
          )} is deleted`,
          { color: "red" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch("company/deleteCoreValue", this.coreValue.id)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess(
              `${this.t("core_values.title_s")} deleted`
            );
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while deleting"
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined ::v-deep .v-input__append-outer {
  margin-top: 0 !important;
}
</style>
